import ReceivedLogs from '../../components/pages/mypages/ReceivedLogs'
export default {
  components: { ReceivedLogs }
}
